module.exports = __webpack_public_path__ + "static/media/phone-fill.3c521f94.svg";